/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Private_ModelsInputs */



/**
* | output |
* | --- |
* | "Can we use our own models?" |
*
* @param {Uno_Welcome_Suggestion_Private_ModelsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_private_models = /** @type {((inputs?: Uno_Welcome_Suggestion_Private_ModelsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Private_ModelsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Können wir eigene Modelle nutzen?")
	return /** @type {LocalizedString} */ ("Can we use our own models?")
});